var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovateBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 2117,
    viewBox: "0 0 960 2117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M561.815 842.356C588.136 815.897 617.541 804.654 658.12 796.427C706.822 789.194 748.36 759.649 774.646 719.994C806.822 671.454 818.398 612.119 806.826 555.044C795.255 497.969 761.484 447.828 712.944 415.652C664.403 383.476 605.069 371.9 547.994 383.472C490.918 395.043 440.778 428.814 408.601 477.354C388.381 507.858 370.218 548.506 383.587 614.447C390.786 649.954 392.912 686.489 378.793 721.036",
    stroke: "#451DAB",
    strokeOpacity: 0.4,
    strokeWidth: 73.1935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.557 842.078L481.579 963.398",
    stroke: "#451DAB",
    strokeOpacity: 0.4,
    strokeWidth: 73.1935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M248.825 983.342L370.84 1064.22",
    stroke: "#451DAB",
    strokeOpacity: 0.4,
    strokeWidth: 73.1935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268.862 120.729C262.814 109.562 262.027 98.8785 263.316 84.8486C265.724 68.2687 260.159 51.8405 249.807 39.3938C237.136 24.1581 218.931 14.5802 199.197 12.7671C179.464 10.954 159.819 17.0542 144.583 29.7258C129.347 42.3973 119.769 60.6022 117.956 80.3356C116.143 100.069 122.243 119.714 134.915 134.95C142.878 144.524 154.348 154.421 177.147 156.516C189.423 157.644 201.538 160.525 211.416 168.507",
    stroke: "#451DAB",
    strokeOpacity: 0.5,
    strokeWidth: 24.9061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M243.014 206.5L300.46 158.722",
    stroke: "#451DAB",
    strokeOpacity: 0.5,
    strokeWidth: 24.9061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M284.187 236.529L322.484 204.677",
    stroke: "#451DAB",
    strokeOpacity: 0.5,
    strokeWidth: 24.9061,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M561.458 1743.66C541.468 1712.14 537.001 1680.98 537.944 1639.59C541.651 1590.49 522.015 1543.45 489.149 1509.05C448.918 1466.95 393.608 1442.55 335.387 1441.22C277.166 1439.89 220.802 1461.75 178.695 1501.98C136.589 1542.21 112.188 1597.52 110.862 1655.74C109.536 1713.96 131.392 1770.33 171.623 1812.43C196.904 1838.89 232.535 1865.59 299.8 1867.12C336.019 1867.95 372.121 1873.95 402.695 1895.35",
    stroke: "#451DAB",
    strokeOpacity: 0.4,
    strokeWidth: 73.1935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M503.016 2000.35L661.779 1848.66",
    stroke: "#451DAB",
    strokeOpacity: 0.4,
    strokeWidth: 73.1935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M629.797 2080.07L735.639 1978.94",
    stroke: "#451DAB",
    strokeOpacity: 0.4,
    strokeWidth: 73.1935,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovateBackdrop);
export default __webpack_public_path__ + "static/media/innovate-backdrop.a1177e3888d200dc93ee9cf7a96450ba.svg";
export { ForwardRef as ReactComponent };